module.exports = __webpack_public_path__ + "img/ic_leadership.04771fbc.png";